import { render, staticRenderFns } from "./BrandSelectorCore.vue?vue&type=template&id=5e53b7f9&"
import script from "./BrandSelectorCore.vue?vue&type=script&lang=js&"
export * from "./BrandSelectorCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports